import React, { Component } from 'react';
import { withRouter } from 'react-router-dom';
import { connect } from 'react-redux';
import common from '~/common';
import Actions from '~/Actions';
import permission from '~/skills/permission';
import { CircularProgress, Dialog } from '@mui/material';

class Background_Execution extends Component {
  componentDidMount () {
    const { history, getJwTNewToken } = this.props;
    const firstPath = history.location.pathname;
    const isManage = firstPath.indexOf(`${common.rootPath}/Manage`) > -1;

    const toLoginAry = ['/Login', '/Login/FogetPsd'];
    if (toLoginAry.indexOf(firstPath.replace(common.rootPath + (isManage ? '/Manage' : ''), '')) > -1) {
      history.push(`${common.rootPath + (isManage ? '/Manage' : '')}/Login`);
    } else if (firstPath.match('/Login/ChangePsd/') || firstPath.match('/Login/ActiveAct/')) {
      //
    } else {
      if (localStorage.getItem('refresh_token')) {
        getJwTNewToken();
      } else history.push(`${common.rootPath + (isManage ? '/Manage' : '')}/Login`);
    }

    this.handleManageState();
  }

  componentDidUpdate (preProp) {
    const { jwtNewwToken: preJwtNewwToken = {} } = preProp;
    const { jwtNewwToken = {}, history, pathAry = [], handlePermission = {}, setHandlePermission, atyFunction } = this.props;
    const firstPath = history.location.pathname;
    const isManage = firstPath.indexOf(`${common.rootPath}/Manage`) > -1;

    if (
      Object.keys(preJwtNewwToken).length === 0 &&
      Object.keys(jwtNewwToken).length > 0 &&
      jwtNewwToken.status !== '200'
    ) {
      history.push(`${common.rootPath + (isManage ? '/Manage' : '')}/Login`);
    }

    if (
      Object.keys(preJwtNewwToken).length === 0 &&
      Object.keys(jwtNewwToken).length > 0 &&
      jwtNewwToken.status === '200'
    ) {
      if (firstPath.match('/Login/Detail') || firstPath === ('/') || firstPath === ('/Manage')) {
        if (isManage)history.push(`${common.rootPath}/Manage/Main`);
        else history.push(`${common.rootPath}/Gis`);
      }
    }

    this.handleManageState();

    // 新增編輯刪除權限
    const newHandlePermission = permission.getPermission(pathAry);
    if (JSON.stringify(newHandlePermission) !== JSON.stringify(handlePermission)) {
      setHandlePermission(newHandlePermission);
    }

    // 前台檢視權限
    const canViewGis = !atyFunction || atyFunction?.fe_report_view;
    if (!isManage && !canViewGis)history.push(`${common.rootPath}/Manage/Main`);
  }

  handleManageState=() => {
    const { history, isManage, setManage } = this.props;
    if ((history.location.pathname.indexOf(`${common.rootPath}/Manage`) > -1) !== isManage) {
      setManage(!isManage);
    }
    this.setTitle();
  }

  setTitle=() => {
    const { isManage } = this.props;
    document.title = isManage ? common.backTitle : common.frontTitle;
  }

  render () {
    const { isLoading } = this.props;
    return (
      <Dialog
        PaperComponent={() => <CircularProgress />}
        open={isLoading}
      />
    );
  }
}
const mapStateToProps = state => ({
  session: state.session,
  jwtNewwToken: state.JWT.NewToken,
  pathAry: state.data.PathAry,
  isManage: state.isManage,
  handlePermission: state.data.HandlePermission, // 新增編輯刪除權限
  isLoading: state.loading.length > 0,
  atyFunction: state.data.AtyFunction,
});
const mapDispatchToProps = dispatch => ({
  getJwTNewToken: () => Actions.getJwTNewToken(dispatch),
  setHandlePermission: body => dispatch({ type: 'post', body, label: 'HandlePermission' }),
  setManage: bol => dispatch({ type: 'setIsManage', value: bol }),
});

export default withRouter(connect(mapStateToProps, mapDispatchToProps)(Background_Execution));
